/*
 * @Author: cmchiu
 * @Date: 2023-05-25 14:54:33
 * @LastEditTime: 2023-05-30 18:18:35
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \IACMP\IACMP_Client\src\api\teacher.js
 *
 */
import request from '@/utils/request'

export const getColgLs = () => {
    return request({
        url: '/Portal/GetColgLs',
        method: 'get',
        withCredentials: true,
    })
}

export const getDeptLs = params => {
    return request({
        url: '/Portal/GetDeptLs',
        method: 'get',
        params,
        withCredentials: true,
    })
}

export const getTeacherLs = data => {
    return request({
        url: '/Portal/GetTeacherLs',
        method: 'post',
        data,
        withCredentials: true,
    })
}

export const getTeacherInfo = params => {
    return request({
        url: '/Portal/GetTeacherInfo',
        method: 'get',
        params,
        withCredentials: true,
    })
}
